import axiosInstance from "../config/axiosConfig";

export interface UserDirectoryDevice {
    name: string;
    os: string;
    lastSignInDateTime?: string | null;
}

export interface UserDirectoryItem {
    id: string;
    displayName: string;
    mail: string;
    jobTitle: string;
    image?: string;
    department: string;
    phoneNumber: string;
    branch: string;
    city: string;
    region: string;
    device: UserDirectoryDevice[];
    callsMade: number;
    callsReceived: number;
    meetingJoined: number;
    meetingOrganized: number;
    voicemail: number;
    status: boolean;
}

export interface UserDirectoryRequest {
    userName?: string | null;
    departments: string[];
    isPstnUser?: boolean;
    page: number;
    pageSize: number;
    startTime?: string | null;
    endTime?: string | null;
    agentIds?: string[] | null;
}

export interface UserDirectoryResponse {
    items: UserDirectoryItem[];
    totalCount: number;
    page: number;
    pageSize: number;
}

export async function fetchUserDirectoryDepartments(options?: { signal?: AbortSignal }): Promise<string[]> {
    const response = await axiosInstance.get<string[]>("/agents/directory/departments", {
        signal: options?.signal,
    });
    return response.data;
}

export async function fetchUserDirectory(
    payload: UserDirectoryRequest,
    options?: { signal?: AbortSignal }
): Promise<UserDirectoryResponse> {
    const { userName, ...restPayload } = payload;
    const normalizedUserName = userName?.trim();
    const requestBody: UserDirectoryRequest = {
        ...restPayload,
        ...(normalizedUserName ? { userName: normalizedUserName } : {}),
    };

    const response = await axiosInstance.post<UserDirectoryResponse>("/agents/directory", requestBody, {
        signal: options?.signal,
    });
    return response.data;
}
